import TablePagination from '../component/TablePagination';
import { brand } from "../config/brands";
// src/pages/PendingOrders.js
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import './Categories.css';
import { ArrowUpTrayIcon,  EllipsisVerticalIcon, PencilIcon, PhoneArrowUpRightIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ApiUrlService } from '../api-library/api-services';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Categories = () => {

  let emptyCategory = {
    categoryId: '',
    name: '',
    priority: '',
    image: ''
  }

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 12;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState(emptyCategory);
  const [categoryName, setCategoryName] = useState("");
  const [priority, setPriority] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);
 

  

  // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("Categories", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "Name", "Priority", "Image" ];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.categoryId,
    order.name,
    order.priority,
    order.image
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("categories.pdf");
};

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);
  };
  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  const confirmDelete = () => {
   
    handleDeleteCategory(selectedItem);
  
  };

 


  const handleDeleteCategory = async (category) =>{
    try {

      var service = apiUrlService.DeleteApi();
      fetch(`${brand.apiBaseUrl}/category/` + category.categoryId + '', service).then(res => res.json())
          .then(response => {
              setLoading(false)
              if (response.status === true) {
                toast.success("Category Deleted!");
                  setShowConfirmModal(false);
                  setCategory(emptyCategory);
                  getCategories()
              }else{
       
                toast.error("Error deleting category!");
              
              
              }
          })


    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }

    // Derived states
    const filteredOrders = orders.filter((order) => {
      const search = searchTerm.toLowerCase();
      return (
        order.name?.toString().toLowerCase().includes(search) ||
        order.categoryId?.toLowerCase().includes(search) ||
        order.priority?.toString().toLowerCase().includes(search) 
      );
    });
  
    const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
    const paginatedOrders = filteredOrders.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );

    const handleSearchChange = (e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1); // Reset to first page on search
    };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setCategory((prevCategory) => ({
          ...prevCategory,
          image: response.data.data, // Update image URL
        }));
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const addNewCategory = async () => {

    const body =
    {
      "name": categoryName,
      "priority": priority,
      "image": category.image
    }
    var service = apiUrlService.PostApi(body)
    fetch(`${brand.apiBaseUrl}/category`, service).then((response) => response.json())
      .then((response) => {
        setLoading(false)
        if (response.status === true) {
          toast.success("Category Created!");
          setAddModalOpen(false)
          setCategoryName("")
          setPriority("")
          setImage("")
          getCategories()

        }
      })

  }


  const handleEditOrder = (item) => {

    const body =
    {
      "name": categoryName,
      "priority": priority,
      "image": category.image ? category.image : item.image
    }

    var service = apiUrlService.PutApi(body)
    fetch(`${brand.apiBaseUrl}/category/` + item.categoryId + '', service).then((response) => response.json())
      .then((response) => {

        if (response.status === true) {
          toast.success("Category Updated!");
          setIsModalOpen(false)
          getCategories()
        }
      })
  };

  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedOrder.items.filter((_, i) => i !== index);
    setSelectedOrder({ ...selectedOrder, items: updatedItems });
  };

  const apiUrlService = new ApiUrlService()

  useEffect(() => {
    getCategories()

  }, []);

  useEffect(() => {
    if (selectedOrder) {
      setCategoryName(selectedOrder.name || "");
      setPriority(selectedOrder.priority || "");
    }
  }, [selectedOrder]);

  const getCategories = () => {
    setOrders([])
    setLoading(true)
    var service = apiUrlService.GetApi()
    fetch(`${brand.apiBaseUrl}/category`, service).then(res => res.json())
      .then(response => {
        setOrders(response.data)
        setLoading(false)


      });
  }


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedOrder(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null); // Clear selected order when closing the modal
  };


  return (
    <Layout>
      <div className="category-page">
      <ToastContainer />
      <header className="category-header"><p>{brand.displayName.toUpperCase()} / CATALOG</p><h1>Categories</h1><span>Organize your catalog, one category at a time.</span></header>
      <div className="category-collection">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
          <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search categories…" aria-label="Search categories"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
          </div>

          <div className="npb-3 flex">
            <button onClick={() => setAddModalOpen(true)}
              className="px-4 py-2 bg-yellow flex mr-5 text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New Category
            </button>
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <div className="category-grid" aria-label="Categories" aria-busy={loading}>
          {paginatedOrders.map(order => <article className="category-card" key={order.categoryId}>
            <button type="button" className="category-preview" onClick={() => openModal(order)} aria-label={`Edit ${order.name}`}>
              <span className="category-fallback" aria-hidden="true">{order.name?.charAt(0).toUpperCase() || 'C'}</span>
              {order.image && <img key={order.image} src={order.image} alt="" loading="lazy" onError={event => { event.currentTarget.style.display = 'none'; }} />}
            </button>
            <div className="category-info"><div><h2 title={order.name}>{order.name}</h2><span>Priority {order.priority ?? '—'}</span></div>
              <button type="button" className="category-menu-toggle" aria-label={`Actions for ${order.name}`} aria-expanded={dropdownOpenId === order.categoryId} onClick={() => toggleDropdown(order.categoryId)}><EllipsisVerticalIcon /></button>
            </div>
            {dropdownOpenId === order.categoryId && <div className="category-menu"><button onClick={() => openModal(order)}><PencilIcon />Edit category</button><button className="category-delete" onClick={() => { toggleDropdown(null); handleDeleteClick(order); }}><TrashIcon />Delete category</button></div>}
          </article>)}
        </div>
        {!paginatedOrders.length && <div className="category-empty" role="status">{loading ? 'Loading categories…' : searchTerm ? 'No categories match your search.' : 'No categories yet. Add your first category to get started.'}</div>}
        {/* Pagination */}
      <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">
       

        {/* Modal */}
        {isModalOpen && selectedOrder && (
          <div className="category-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="category-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Category Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />


              <div>

                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>

                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Category Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />

                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={category.image || selectedOrder.image || "placeholder_image_url"}
                    alt="Category"
                    className="w-16 h-16 rounded-lg object-cover"
                  />
                  <label className="cursor-pointer px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleImageChange}
                    />
                  </label>
                </div>

              </div>



              <div className="flex justify-center space-x-2 pt-10">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleEditOrder(selectedOrder)}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}


        {/* Add Category Modal */}
        {addModalOpen && (
          <div className="category-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="category-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-lg font-semibold mb-4">Add Category</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Category Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  //value={newQuantity}
                  placeholder='Priority'
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                //onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Category Image
                </label>
                <input
                  type="file"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  accept="image/*"
                  onChange={handleImageChange}
                />

                {image && (
                  <div className="mt-2">
                    <img
                      src={URL.createObjectURL(image)}
                      alt="Selected Category"
                      className="w-32 h-32 object-cover rounded"
                    />
                  </div>
                )}
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => addNewCategory()}
                //onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

  {/* Confirmation Modal */}
  {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this category?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
    </Layout>
  );
};

export default Categories;
